import { useMemo, useRef } from 'react';
import isEqual from 'lodash.isequal';
import { useSelector } from 'react-redux';

import Global from '../../../../store/global-selectors';

/**
 * @typedef {object} WarehouseLocation
 * @property {string} area - The area name of the warehouse location
 * @property {number} inventoryLocationId - The ID of the inventory location
 */

/**
 * Custom hook to get warehouse locations with memoization to prevent unnecessary re-renders
 * @param {string|number} warehouseId - The ID of the warehouse to get locations for
 * @returns {Array<WarehouseLocation>} The warehouse locations for the specified warehouse
 */
export const useWarehouseLocations = (warehouseId) => {
  const rawWarehouseLocations = useSelector((state) =>
    Global.selectSellerInventoryWarehouseLocationsByWarehouseId(state, {
      inventoryWarehouseId: warehouseId,
    }),
  );

  const prevRef = useRef();

  return useMemo(() => {
    if (isEqual(prevRef.current, rawWarehouseLocations)) {
      return prevRef.current;
    }
    prevRef.current = rawWarehouseLocations;
    return rawWarehouseLocations;
  }, [rawWarehouseLocations]);
};
